// hooks/useApiClients.ts
import {
  AppApi as BackendAppApi,
  AuthApi as BackendAuthApi,
  StripeApi as BackendStripeApi,
  RolesApi as BackendRolesApi,
  DepartmentsApi as BackendDepartmentApi,
  IncidentReportingApi as BackendIncidentReportingApi,
  UsersApi as BackendUserApi,
  CorrectiveActionApi as BackendCorrectiveActionApi,
  StatisticsApi as BackendStatisticsApi,
  CustomIncidentTypesApi as BackendCustomIncidentTypesApi,
  UserSettingsApi as BackendUserSettingsApi,
  BulkUploadsApi as BackendBulkUploadsApi,
  InvestigationQuestionCategoryApi as BackendInvestigationQuestionCategoryApi,
  InvestigationQuestionApi as BackendInvestigationQuestionApi,
  InvestigationReportingApi as BackendInvestigationReportingApi,
  DocumentLibraryApi as BackendDocumentLibraryApi,
  EstablishmentApi as BackendEstablishmentApi,
  OshaReportingApi as BackendOshaReportingApi,
  AdminApi as BackendAdminApi,
  OnboardOrganizationApi as BackendOnboardOrganizationApi,
} from '@EHSNavigator/backend';
import useAuthenticatedAxios from './useAuthenticatedAxios';

const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';

export const useApiClients = () => {
  const axios: any = useAuthenticatedAxios();
  
  const AppApi = new BackendAppApi(
    undefined,
    BASE_URL,
    axios
  );
  const AuthApi = new BackendAuthApi(
    undefined,
    BASE_URL,
    axios
  );
  const StripeApi = new BackendStripeApi(
    undefined,
    BASE_URL,
    axios
  );
  const RolesApi = new BackendRolesApi(
    undefined,
    BASE_URL,
    axios
  );
  const DepartmentApi = new BackendDepartmentApi(
    undefined,
    BASE_URL,
    axios
  );
  const IncidentReportingApi = new BackendIncidentReportingApi(
    undefined,
    BASE_URL,
    axios,
  );
  const UserApi = new BackendUserApi(
    undefined,
    BASE_URL,
    axios
  );
  const CorrectiveActionApi = new BackendCorrectiveActionApi(
    undefined,
    BASE_URL,
    axios,
  );
  const StatisticsApi = new BackendStatisticsApi(
    undefined,
    BASE_URL,
    axios
  );
  const CustomIncidentTypesApi = new BackendCustomIncidentTypesApi(
    undefined,
    BASE_URL,
    axios,
  );
  const UserSettingsApi = new BackendUserSettingsApi(
    undefined,
    BASE_URL,
    axios,
  );
  const BulkUploadsApi = new BackendBulkUploadsApi(
    undefined,
    BASE_URL,
    axios
  );
  const InvestigationQuestionCategoryApi = new BackendInvestigationQuestionCategoryApi(
    undefined,
    BASE_URL,
    axios
  );
  const InvestigationQuestionApi = new BackendInvestigationQuestionApi(
    undefined,
    BASE_URL,
    axios,
  );
  const InvestigationReportingApi = new BackendInvestigationReportingApi(
    undefined,
    BASE_URL,
    axios,
  );
  const DocumentLibraryApi = new BackendDocumentLibraryApi(
    undefined,
    BASE_URL,
    axios,
  );
  const EstablishmentApi = new BackendEstablishmentApi(
    undefined,
    BASE_URL,
    axios,
  );
  const OshaReportingApi = new BackendOshaReportingApi(
    undefined,
    BASE_URL,
    axios,
  );
  const AdminApi = new BackendAdminApi(
    undefined,
    BASE_URL,
    axios
  );
  const OnboardOrganizationApi = new BackendOnboardOrganizationApi(
    undefined,
    BASE_URL,
    axios
  );

  return {
    AppApi,
    UserApi,
    AuthApi,
    RolesApi,
    StripeApi,
    DepartmentApi,
    CorrectiveActionApi,
    IncidentReportingApi,
    StatisticsApi,
    CustomIncidentTypesApi,
    UserSettingsApi,
    BulkUploadsApi,
    InvestigationQuestionCategoryApi,
    InvestigationQuestionApi,
    InvestigationReportingApi,
    DocumentLibraryApi,
    EstablishmentApi,
    OshaReportingApi,
    AdminApi,
    OnboardOrganizationApi,
  };
};
